export default {
  agencyId: 1, // 机构id
  loginCallback: process.env.VUE_APP_MODEL_LOGIN_BACK_URL, // 微信登录回调前端地址
  wechatAppId: 'wx2765615d35d3d78a',
  webTitle: '高新区' // 网站标题
}



// WEBPACK FOOTER //
// ./src/comm/config/appConfig.js